
import {defineComponent} from "vue";

const __default__ = defineComponent({
  name: "ContentAlertModal",
  props: {
    text: {
      type: String,
      default: "Mensagem"
    },
    width: {
      type: String
    }
  },
  setup(props, {emit}) {
    let modalWidth: string = "";
    if (props.width) {
      modalWidth = props.width;
    }

    const closeMessage = async (): Promise<void> => {
      emit("closeContentAlertModal");
    };

    return {
      modalWidth,
      closeMessage
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "a8706b5a": (_ctx.modalWidth)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__